// tree-view-core.js — logica PURA del componente condiviso TreeView (F2.3h,
// TERZO mattone del design system in client/src/ui/).
// File PURO (niente JSX, niente DOM): è QUESTO che il contract test
// server/src/lib/tree-view.test.js esercita sotto node --test — il JSX
// (TreeView.jsx) resta un guscio di resa che DELEGA qui ogni decisione.
//
// RIUSO, NON FORK (stessa filosofia di card-grid-core, mandato ondata 22/23):
// la selezione dello stato e la chiave hanno la STESSA semantica del
// DataTable/CardGrid — si delega a data-table-core, che NON si tocca.

import { selectTableState, rowKeyOf } from './data-table-core.js';

// Selezione dello stato da mostrare. Precedenza DICHIARATA (identica a
// DataTable/CardGrid, testata):
//  - RIGHE VISIBILI presenti ⇒ 'data' SEMPRE (reload in corso o fallito NON
//    svuota l'albero: il chiamante comunica l'errore col suo banner);
//  - senza righe visibili: error › loading › 'empty' (messaggio dedicato).
// NB: si decide sulle righe GIÀ appiattite (flattenTree), non sulle radici:
// un filtro che nasconde tutto = stato vuoto (parità col v1 delle Categorie,
// che mostra il messaggio quando il join delle righe rese è '').
export function selectTreeState(s) {
  return selectTableState({
    rows: (s && s.entries) || [],
    loading: s && s.loading,
    error: s && s.error,
  });
}

// Chiave di riga albero: campo (stringa), funzione, fallback indice — mai
// undefined. Stessa funzione del DataTable (prefisso di fallback 'row-').
export function treeKeyOf(node, nodeKey, index) {
  return rowKeyOf(node, nodeKey, index);
}

// Indentazione della riga: la formula del monolite (depth*24+8, v1:8350) coi
// parametri espliciti — il consumatore può dichiarare base/step diversi.
export function indentPx(depth, opts) {
  const base = opts && typeof opts.base === 'number' ? opts.base : 8;
  const step = opts && typeof opts.step === 'number' ? opts.step : 24;
  return depth * step + base;
}

// Appiattimento dell'albero in righe ORDINATE di resa (walk depth-first,
// stesso ordine del renderNode ricorsivo del v1):
//   {kind:'node', node, depth, hasChildren, isOpen}
// e, DOPO i figli di un nodo aperto, l'eventuale riga di coda
//   {kind:'trailing', node, depth: depth+1, data}
// (es. "⋯ altre N categorie" del v1: data = ciò che ritorna opts.trailing).
// Opzioni (tutte funzioni del consumatore — la vista decide, il core cammina):
//   getChildren(node)  → figli (default node.children || [])
//   isVisible(node)    → false = nodo E sottoalbero esclusi (default true)
//   isExpanded(node)   → true = i figli si emettono (default false)
//   trailing(node)     → valore truthy = riga di coda dopo i figli (default no)
// PURA: non muta né i nodi né le opzioni.
export function flattenTree(roots, opts) {
  const o = opts || {};
  const getChildren = typeof o.getChildren === 'function' ? o.getChildren : (n) => (n && n.children) || [];
  const isVisible = typeof o.isVisible === 'function' ? o.isVisible : () => true;
  const isExpanded = typeof o.isExpanded === 'function' ? o.isExpanded : () => false;
  const trailing = typeof o.trailing === 'function' ? o.trailing : () => null;
  const out = [];
  const walk = (node, depth) => {
    if (!isVisible(node)) return;
    const children = getChildren(node) || [];
    const hasChildren = children.length > 0;
    const isOpen = hasChildren && !!isExpanded(node);
    out.push({ kind: 'node', node, depth, hasChildren, isOpen });
    if (isOpen) {
      for (const c of children) walk(c, depth + 1);
      const t = trailing(node);
      if (t) out.push({ kind: 'trailing', node, depth: depth + 1, data: t });
    }
  };
  for (const r of roots || []) walk(r, 0);
  return out;
}
